/**
 * APC Algolia Collection Page
 *
 * Initializes the Algolia product list on collection pages.
 * Uses collection_ids filtering from the Algolia Shopify integration.
 */

import { apcAlgoliaClient } from '@theme/apc-algolia-client';
import { ApcAlgoliaProductList } from '@theme/apc-algolia-product-list';

function init() {
  if (!apcAlgoliaClient.isEnabled) return;

  const resultsListEl = document.querySelector('results-list');
  if (!(resultsListEl instanceof HTMLElement)) return;

  const collectionId = resultsListEl.dataset.apcAlgoliaCollectionId || '';
  const collectionHandle = resultsListEl.dataset.apcAlgoliaCollectionHandle || '';
  const isAllProducts = collectionHandle === 'all';

  if (!collectionId && !isAllProducts) {
    console.info('[APC Algolia] No collection ID found.');
    return;
  }

  const collectionTitle = resultsListEl.dataset.apcAlgoliaCollectionTitle || '';
  const tResultsCount = resultsListEl.dataset.apcAlgoliaTResultsCount || '{{ count }} results';

  /** @type {import('./apc-algolia-product-list.js').ApcAlgoliaProductListOptions} */
  const options = {
    query: '',
    manageQueryParam: false,
    resultsTextFn: (total) => {
      const countText = `<strong>${tResultsCount.replace('__COUNT__', String(total))}</strong>`;
      return collectionTitle ? `${countText} ${collectionTitle}` : countText;
    },
  };

  // Use collection_ids filtering — skip on /collections/all to show all indexed products
  if (collectionId && !isAllProducts) {
    options.filters = `collection_ids:${collectionId}`;
  }

  new ApcAlgoliaProductList(resultsListEl, options);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
